export const colors = {
  /////////////////////////////////// DARK theme colors /////////////////////////////////////////
  dark: {
    // Some colors are REPEATED under different variable names
    background: "#121212", // Main background colour.  *Also set in index.html
    dialogBkg: "#1f1f1f", // Dialog bkg such as SaveStudyDialog, LockStudyDialog, etc.
    cardBkg: "#1f1f1f", // Card bag such as NewStudy card bkg, StartPage card bkg, etc.
    headerBkg: "#000000", // Header bar bkg
    locationListHeader: "#121212", // Header of the location list
    bkg1: "#212121", // Left column bkg, and acquire bar bkg. Some buttons use this color as bckg as well
    bkg2: "#121212", // Center column bkg
    bkg3: "#212121", // Right column bkg

    locationListTabSelected: "#212121",
    locationListTabUnselected: "#212121",
    tableHeader: "#121212",
    tableSubRow: "#1f1f1f",
    locationInfo: "#1f1f1f",
    keyboardColor: "#ffffff1a",

    // CSI. Main accent color, teal.
    primary: "#71DDFA",
    primaryLight: "#ADEAFB",
    primaryOverlay: "rgba(113, 221, 250,0.2)",
    // BMODE. Secondary accent color, purple .
    secondary: "#8F71FA",
    secondaryLight: "#c4a0ff",
    secondaryOverlay: "rgba(196,160,255,0.2)",
    // PHOTO. Tertiary accent color, orange.
    tertiary: "#FA8F71",
    tertiaryLight: "#ba81ffcc",
    // Progress Bar colors (progress bar next to location)
    primaryProgressBarAcquired: "rgba(113, 221, 250,0.4)",
    secondaryProgressBarAcquired: "rgba(196,160,255,0.4)",
    progressBarBkg: "#4a4a4a42",
    progressBarBkgHeader: "rgba(74, 74, 74, 0.55)",

    boxShadowColor: "rgba(175,175,175",
    locationPlotBkg: "#121212",
    menuHoverColor: "rgba(255, 255, 255, 0.16)",
    tableHover: "rgba(255, 255, 255, 0.08)",
    iconButtonIconColor: "rgba(0, 0, 0, 0.87)",
  },
  ///////////////////////////// LIGHT theme colors//////////////////////////////////////////
  light: {
    // Some colors are REPEATED under different variable names
    background: "#303445", // Main background colour.  *Also set in index.html
    dialogBkg: "#373C52", // Dialog bkg such as SaveStudyDialog, LockStudyDialog, etc.
    cardBkg: "#383c51", // Card bag such as NewStudy card bkg, StartPage card bkg, etc.
    headerBkg: "#272b3d", // Header bar bkg
    locationListHeader: "#232738", // Header of the location list
    bkg1: "#373C52", // Left column bkg, and acquire bar bkg. Some buttons use this color as bckg as well
    bkg2: "#313546", // Center column bkg
    bkg3: "#242839", // Right column bkg

    locationListTabSelected: "#373C52",
    locationListTabUnselected: "rgba(55, 60, 82, 0.5)",

    tableHeader: "#242839",
    tableSubRow: "#2e3348",
    locationInfo: "#242839",
    keyboardColor: "#4a4f67",
    // CSI. Main accent color, teal.
    primary: "#92CBC5",
    primaryLight: "#c4fef8",
    primaryOverlay: "rgba(146,203,197,0.2)",
    // BMODE. Secondary accent color, purple .
    secondary: "#6f8acc",
    secondaryLight: "#a1baff",
    secondaryOverlay: "rgba(111,138,204,0.2)",
    // PHOTO. Tertiary accent color, orange.
    tertiary: "#F7A03C",
    tertiaryLight: "#ffd16c",
    // Progress Bar colors (progress bar next to location)
    primaryProgressBarAcquired: "#92CBC5",
    secondaryProgressBarAcquired: "#6f8acc",
    progressBarBkg: "rgba(0, 0, 0, 0.26)",
    progressBarBkgHeader: "rgba(0, 0, 0, 0.26)",

    boxShadowColor: "rgba(0,0,0",
    locationPlotBkg: "#383c51",
    menuHoverColor: "rgba(255, 255, 255, 0.16)",

    tableHover: "rgba(255, 255, 255, 0.08)",
    iconButtonIconColor: "#313546",
  },

  ///////////////////////////// THEME INDEPENDENT //////////////////////////////////////
  disabledColor: "rgba(255, 255, 255, 0.3)",
  progressBarBkgLocation: "rgba(0, 0, 0, 0.26)",
  dialogTabUnselected: "rgba(255, 255, 255, 0.05)",
  dialogBoxShadow: "rgba(175, 175, 175, 0.2) 0px -3px 4px 0px",
  textDisabled: "rgba(255, 255, 255, 0.5)",

  collapseButtonHover: "rgba(0,0,0,0.2)",
  iconButtonColor: "rgba(255, 255, 255, 0.7)",
  iconButtonHoverColor: "rgb(224, 224, 224)",
  iconButtonDisabledColor: "rgba(255, 255, 255, 0.12)",

  // BodyMap Heatmap color bar range
  cbar_white: "#EEEEEE",
  cbar_teal: "#92CBC5",
  cbar_orange: "#CCB532",
  cbar_red: "#C14A4A",
  mapGrey: "rgba(255, 255, 255, 0.3)", // grey color used in location marker
  facePrimary: "rgb(190, 190, 190)",
  faceSecondary: "rgb(200, 200, 200)",
  faceTertiary: "rgba(175, 175, 175)",
  faceErase: "rgba(255, 255, 255, 1)",
  faceStrokeHover: "rgb(100, 100, 100)",
  cameraBackground: "rgb(204, 204, 204)",

  secondaryText: "rgba(255, 255, 255, 0.7)",
  warning: "#c5b451", //Snackbar warning
  error: "#E47577", //Snackbar error
  snackbarText: "#383c51",
  ///////////////////////////// Highcharts style /////////////////////////////////////////
  // These colors are used in each chart's Options.js file.
  chartTitle: "#FFFFFF", // alternative color: "#ccd6eb"
  chartAxisLabel: "#FFFFFF",
  chartAxisBkg: "rgba(0,0,0,0.2)",
  chartToolTipBkg: "rgba(0, 0, 0, 0.3)",
  chartNullColor: "#EFEFEF",

  plotBandROI: "rgba(255, 255, 255, 0)",
  swsPlotLine: "rgba(255, 255, 255, 1)",
  swsPlotLineBkg: "rgba(0, 255, 0, 0)",
  swsPlotStrokeColor: "rgba(255, 255, 255, 0.3)",
  swsPlotNoGoZoneBkg: "rgba(0, 0, 0, 0.5)",
  swsPlotColorStop0: "rgb(255,0,0)",
  swsPlotColorStop1: "rgb(255,77.3,0)",
  swsPlotColorStop2: "rgb(255, 149.8,78.7)",
  swsPlotColorStop3: "rgb(230.5,205.3,115)",
  swsPlotColorStop4: "rgb(178.5,242.5,149.8)",
  swsPlotColorStop5: "rgb(128.5,254.9,179.7)",
  swsPlotColorStop6: "rgb(76.5,242.5,206.2)",
  swsPlotColorStop7: "rgb(24.5,205.3,227.5)",
  swsPlotColorStop8: "rgb(25.5,149.8,242.5)",
  swsPlotColorStop9: "rgb(77.5,77.3,251.9)",
  swsPlotColorStop10: "rgb(127.5,0,255)",

  // Color bar limits for multi frame CSI graph
  velocitySlicePlotColorStop1: "#92CBC5",
  velocitySlicePlotColorStop2: "#1861AA",
  velocitySlicePlotColorStop3: "#000000",
  velocitySlicePlotColorStop4: "#F56363",
  velocitySlicePlotColorStop5: "#E37F33",
  velocitySlicePlotColorStop6: "#CCB532",

  bmodeLineBkg: "rgba(0, 0, 0, 0.1)",
  calibrationPlot: "rgba(255, 255, 255, 0.8)",
  calibrationPlotBkg: "rgba(0, 0, 0, 0.2)",
  locationPlotGridLine: "#808080",
  // Location review plot line graph line colors
  locationPlotLine1: "#2f7ed8", // blue
  locationPlotLine2: "#0d233a", // navy
  locationPlotLine3: "#8bbc21", // green
  locationPlotLine4: "#910000", // red
  locationPlotLine5: "#1aadce", // light blue
  locationPlotLine6: "#492970", // purple
  locationPlotLine7: "#f28f43", // orange
  locationPlotLine8: "#77a1e5", // lighter blue
  locationPlotLine9: "#c42525", // light red
  locationPlotLine10: "#a6c96a", //light green

  skinType1: "#f4d0b0",
  skinType2: "#e8b48f",
  skinType3: "#d39e7e",
  skinType4: "#bb7750",
  skinType5: "#a45e2b",
  skinType6: "#3c201d",
  skinTypeDisabled: "rgba(49, 49, 49, 0.40)",
  skinTypeText: "#8b4513",
};
